import {
  FETCH_ACTION_DROPDOWN_REQUEST,
  FETCH_ACTION_DROPDOWN_SUCCESS,
  FETCH_ACTION_DROPDOWN_FAILURE,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const terminalActionDropdownReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case FETCH_ACTION_DROPDOWN_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case FETCH_ACTION_DROPDOWN_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case FETCH_ACTION_DROPDOWN_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    default:
      return state;
  }
};

export default terminalActionDropdownReducer;
